import { autoserialize, autoserializeAs } from 'cerialize';

export class Realm {
  @autoserialize url!: string;
  @autoserialize name!: string;
  @autoserializeAs('client_id') clientId!: string;
}
